import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import useBodyOverflowToggle from 'components/hooks/useBodyOverflowToggle';
import useEscapeKey from 'components/hooks/useEscapeKey';

import TextButton from 'components/application/buttons/TextButton';

export default function ModalBox(props) {
  const {
    children,
    customFooter,
    isOpen,
    modalBoxClassName,
    mode,
    onClose,
    secondaryFooter,
    shouldCloseOnWrapperClick,
    usingSlimDimensions,
    usingStandardDimensions,
    withFooter,
  } = props;

  const openCloseClassName = isOpen ? 'modalbox--open' : 'modalbox--close';

  useBodyOverflowToggle(isOpen);

  const modeClassName = {
    landscape: 'modalbox__box--landscape',
    portrait: 'modalbox__box--portrait',
    letterbox: 'modalbox__box--letterbox',
    flexible: 'modalbox__box--flexible',
  }[mode];

  const defaultFooter = (() => {
    if (!withFooter) return;

    return mode === 'portrait' ?
        <TextButton color='blue' onClick={onClose} size='md'>
          Close
        </TextButton>
      : <>
          {secondaryFooter && (
            <div className='modalbox__footer-actions modalbox__footer-actions--left'>
              {secondaryFooter}
            </div>
          )}
          <div className='modalbox__footer-actions modalbox__footer-actions--right'>
            <TextButton color='blue' onClick={onClose} size='md'>
              Close
            </TextButton>
          </div>
        </>;
  })();

  const handleWrapperClick = (event) => {
    if (
      shouldCloseOnWrapperClick &&
      event.target.classList.contains('modalbox__box-wrapper')
    ) {
      onClose();
    }
  };

  useEscapeKey(onClose, [isOpen]);

  return (
    <div
      className={`modalbox ${openCloseClassName}`}
      data-element-name='modalbox'
    >
      <div className='modalbox__scroller'>
        <div className='popup__backdrop tw-bg-grey-900 tw-opacity-75' />
        <div className='modalbox__box-wrapper' onClick={handleWrapperClick}>
          <div
            className={classNames(
              'modalbox__box tw-bg-white',
              modeClassName,
              usingStandardDimensions && 'modalbox__box--standard-dimensions',
              usingSlimDimensions && 'modalbox__box--slim-dimensions',
              modalBoxClassName,
            )}
          >
            <section className='modalbox__children'>{children}</section>
            {withFooter && (
              <section className='modalbox__footer tw-border-b-white tw-border-t-grey-100'>
                {customFooter || defaultFooter}
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

ModalBox.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

ModalBox.defaultProps = {
  mode: 'landscape',
  secondaryFooter: null,
  customFooter: null,
  usingSlimDimensions: false,
  withFooter: true,
  shouldCloseOnWrapperClick: true,
};
